export const unicoUrl = `${window.location.origin}/unico`;

export const moduloProtocoloOnPremise = '4';

export const unicoUrlParams = `?modulo=${moduloProtocoloOnPremise}`;
